import { useTenantConfiguration } from '@/hooks/useTenantConfiguration';
import { localeConfigurations, useTranslation } from '@/i18n';
import { TransText } from '@/i18n/trans/text';
import { typedEntries } from '@/utils/object';
import {
  Button,
  Dialog,
  Icons,
  Typography,
} from '@packages/webshop-design-system';
import { useTranslation as useWidgetTranslation } from '@packages/webshop-search-widget';
import type { FC } from 'react';
import { useState } from 'react';

interface MobileLanguageSelectProps {}

const MobileLanguageSelect: FC<MobileLanguageSelectProps> = () => {
  const [open, setOpen] = useState(false);
  const tenantConfiguration = useTenantConfiguration();
  const {
    i18n: { changeLanguage, language: currentLanguage },
  } = useTranslation();
  const {
    i18n: { changeLanguage: changeWidgetLanguage },
  } = useWidgetTranslation();

  return (
    <Dialog
      isOpen={open}
      onOpenChange={setOpen}
      trigger={
        <Button
          variant="ghostLink"
          className="flex items-center px-0"
          data-testid="language-select-trigger"
        >
          <Icons.globe width={24} height={24} />
          <Typography variant="body1">
            {currentLanguage.toUpperCase()}
          </Typography>
        </Button>
      }
      headerTitle={<TransText i18nKey="selectLanguage" />}
      className={{
        root: 'max-w-md',
        header: 'text-left',
        content: 'p-0',
      }}
      data-testid="mobile-language-select"
    >
      <div className="[&>*:last-child]:rounded-md">
        {typedEntries(localeConfigurations)
          .filter(([code]) =>
            tenantConfiguration?.languageOptions.includes(code)
          )
          .map(([code, config], key) => (
            <Button
              key={key}
              variant="ghostLink"
              onClick={() => {
                changeLanguage(code);
                changeWidgetLanguage(code);
                setOpen(false);
              }}
              data-testid={`language-select-choose-${code}`}
              className="h-14 justify-between rounded-none p-4 hover:bg-primary-light"
            >
              <Typography variant="paragraph">{config.label}</Typography>
              <div className="flex items-center gap-2">
                {code === currentLanguage && (
                  <Icons.checkCircle
                    height={20}
                    width={20}
                    className="text-success-text"
                  />
                )}
                <Typography variant="paragraph">
                  {code.toUpperCase()}
                </Typography>
              </div>
            </Button>
          ))}
      </div>
    </Dialog>
  );
};

export default MobileLanguageSelect;
